import { Component, OnInit, Injector } from '@angular/core';
import { UiEngineComponent } from 'src/modules/base/components/ui-engine/ui-engine.component';
import { Router, ActivatedRoute } from '@angular/router';
import { BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { ModalSize } from 'src/modules/base/services/smart-modal.service';
import { PaymentStatusComponent } from '../payment-status/payment-status.component';
import { DialogModalSize } from 'src/modules/base/components/dialog/dialog-ref';

@Component({
    selector: 'kx-payment-mode-extended',
    templateUrl: './payment-mode-extended.component.html',
    standalone: false
})
export class PaymentModeExtendedComponent extends UiEngineComponent {

  constructor(
    public injector: Injector,
    public router: Router,
    public route: ActivatedRoute,
    public modal: BsModalService
  ) {

    super(injector, router, route, modal);
  }

  ngAfterViewInit() {
    if (this.authenticationService.getUserType().toLowerCase() == 'patient' || this.rolePermissionService.checkAccessPermission('show_payment_status', 'scm_order', 'inventory-management')) {
      this.route.queryParams.subscribe((res: any) => {
        if (res.hasOwnProperty('orderId') || res.hasOwnProperty('admissionId')){
          this.showPaymentPopUp(res);
        }
      })
    }
    // if (this.authenticationService.getUserType().toLowerCase() != 'patient') {
    //   this.router.navigate(['404'])
    // }
  }

  getFilterValues(filterVal) {
    if (this._currentData.bannerJson && this._currentData.bannerJson.key && this._currentData.bannerJson.key != undefined) {
      filterVal = this.baseService.buildDyanamicStr(filterVal, { data: this._currentData.bannerJson.key });
    } else if (this._currentData.resouceDef.config.readqueryparams) {
      filterVal = this.baseService.buildDyanamicStr(filterVal, { data: this.activatedRoute.snapshot.queryParams });
    } else {
      filterVal = this.baseService.buildDyanamicStr(filterVal, {});
    }
    return filterVal
  }

  toggleTabView(event){
    //console.log('clicked');
    event.currentTarget.parentElement.parentElement.classList.toggle('expand');
  }

  showPaymentPopUp(data: any) {
    const config: ModalOptions = {
      backdrop: 'static',
      keyboard: false,
      animated: true,
      ignoreBackdropClick: true,
      initialState: {
        data: data
      }
    };
    this.modal.show(PaymentStatusComponent, config);
  }
}
